/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState, useEffect } from 'react' // eslint-disable-line

import { Drawer, Divider } from 'antd'

import MachineCreateDrawer from './MachineCreateDrawer'
import ShelfCreateDrawer from './ShelfCreateDrawer'
import { ViewerStyles, EditorStyles } from './styles'

interface Props {
  children: any
}

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)

  return (
    <div css={EditorStyles['edit-pane']}>
      <span onClick={
        () => {
          onVisibleChange(true)
        }
      } size="small">{props.children}</span>
      <Drawer
        title="快捷操作"
        width={160}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <MachineCreateDrawer icon="cluster" text="创建机器" block/>
          <Divider/>
          <ShelfCreateDrawer icon="container" text="创建货架" block/>
        </div>
      </Drawer>
    </div>
  )
}